module.exports = {
      id: "ic-zoomin-light-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-zoomin-light-usage",
      toString: function () {
        return this.url;
      }
    }